import { useEffect } from 'react';
import { useTheme } from 'foundations-theming/utils';
import { useIsPillBorderRadius } from '../../hooks/useIsPillBorderRadius';
function buildCss(formId, theme, isPill) {
  var _t$body200$fontFamil, _t$body, _br$;
  const c = theme.color;
  const t = theme.typography;
  const br = theme.borderRadius;
  const bodyFont = (_t$body200$fontFamil = (_t$body = t['body-200']) === null || _t$body === void 0 ? void 0 : _t$body.fontFamily) !== null && _t$body200$fontFamil !== void 0 ? _t$body200$fontFamil : 'inherit';
  const radius = (_br$ = br['100']) !== null && _br$ !== void 0 ? _br$ : '0px';
  const f = `.hs-form-${formId}.hs-form-${formId}`;
  return `
${f} { color: ${c['text-core-default']}; font-family: ${bodyFont}; padding-bottom: 16px; }

${f} .hs-form__field__label { color: ${c['text-core-default']}; font-family: ${bodyFont}; }
${f} .hs-form__field__label__required { color: ${c['fill-alert-default']}; }
${f} .hs-form__field__description, ${f} .hs-form__field__footer { color: ${c['text-core-subtle']}; }

${f} .hs-form__field__input { color: ${c['text-core-default']}; background-color: ${c['fill-field-default']}; border: 1px solid ${c['border-core-default']}; border-radius: ${radius}; font-family: ${bodyFont}; }
${f} .hs-form__field__input::placeholder { color: ${c['text-core-subtle']}; }
${f} .hs-form__field__input:focus { box-shadow: 0 0 3px ${c['border-core-default']}; outline: none; }
${f} textarea.hs-form__field__input { border-radius: ${isPill ? '16px' : radius}; }
${f} .hs-form__field__input--error { border-color: ${c['fill-alert-default']}; }

${f} .hs-form__field__radio__input, ${f} .hs-form__field__checkbox__input { accent-color: ${c['fill-primary-default']}; }

${f} .hs-form__actions__submit { background-color: ${c['fill-primary-default']}; color: ${c['text-primary-default']}; border: none; border-radius: ${radius}; font-family: ${bodyFont}; cursor: pointer; }
${f} .hs-form__actions__submit:hover { opacity: 0.9; }

${f} .hs-form__alerts__list-item--error, ${f} .hs-form__field__error-message { color: ${c['fill-alert-default']}; }


${f}.hs-form__thankyou-message { color: ${c['text-core-default']}; font-family: ${bodyFont}; }
`;
}
export function useV3FormThemeCss(formId) {
  const theme = useTheme();
  const isPill = useIsPillBorderRadius();
  useEffect(() => {
    const styleId = `hs-portals-form-theme-${formId}`;
    let style = document.getElementById(styleId);
    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      document.head.appendChild(style);
    }
    style.textContent = buildCss(formId, theme, isPill);
    return () => {
      var _style;
      (_style = style) === null || _style === void 0 || _style.remove();
    };
  }, [formId, theme, isPill]);
}